import { useState } from 'react';
import { SVG } from 'components/Asset/SVG';
import { LinkButton } from 'components/Buttons/LinkButton';
import { FlexBox } from 'components/Containers/FlexBox';
import { AssetList } from './components/AssetList';
import { CreateAsset } from './components/modals/createAssetModal';
import { useAppSelector } from 'store/hook';
import { SingleFadeLoader } from 'components/SingleFadeLoader';
import { isDarkTheme } from 'utils/theme';
import { ThemePalette } from 'mui.theme';
import { isExternalUser } from 'utils/validators/role.validation';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const AssetListView = () => {
  const { t } = useTranslation();
  const assetsLoaded = useAppSelector(
    (state) => state.assetReducer.assetsLoaded
  );
  const tirePatterns = useAppSelector((state) => state.tirePatternReducer);

  const makeModelDetails = useAppSelector(
    (state) => state.makeModelDetailsReducer
  );
  const customerId = useAppSelector((state) => state.persistedReducer).customer
    .id;

  const { customer, role } = useAppSelector((state) => state.authReducer);
  const theme = customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const isDisabled = isExternalUser(role);

  const [isCreateAssetModalOpen, setIsCreateAssetModalOpen] = useState(false);

  return (
    <>
      {!assetsLoaded ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <SingleFadeLoader />
        </div>
      ) : (
        <>
          <CreateAsset
            key={`${isCreateAssetModalOpen.toString()}-create-user-modal`}
            open={isCreateAssetModalOpen}
            handleAbort={() => {
              setIsCreateAssetModalOpen(false);
            }}
            title={t('add_a_new_asset')}
            enableDarkTheme={enableDarkTheme}
            tirePatterns={tirePatterns}
            makeModelDetails={makeModelDetails}
            customerId={customerId}
          />
          <FlexBox
            sx={{
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <div></div>
            {!isDisabled ? (
              <FlexBox
                sx={{
                  display: 'flex',
                }}
              >
                <SVG
                  name="add"
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    setIsCreateAssetModalOpen(true);
                  }}
                />

                <LinkButton
                  onClick={() => {
                    setIsCreateAssetModalOpen(true);
                  }}
                  sx={{
                    color: enableDarkTheme
                      ? ThemePalette.typography.wheat
                      : ThemePalette.typography.black,
                  }}
                >
                  {t('add_asset_s')}
                </LinkButton>
              </FlexBox>
            ) : (
              <></>
            )}
          </FlexBox>
        </>
      )}

      <AssetList enableDarkTheme={enableDarkTheme} />
    </>
  );
};
